function EmptyStateSection() {
  return (
    <>
      <p>No Data</p>
    </>
  );
}

export default EmptyStateSection;
